import NavigationBar from "../../../components/navbar/NavigationBar";
import PageTitle from "../../../components/Page Title/PageTitle";
import "./TestingApplication.css";

const TestingApplication = () => {
  return (
    <div>
      <NavigationBar />
      <PageTitle title="Request Access" />

      <div className="pagebox pagebox-testapplication">
        <div className="xs section-text text-wrap">
          <p>
            You must be a member of the official{" "}
            <a
              href="https://discord.gg/heroesandgeneralsbeta"
              target="_blank"
              rel="noopener noreferrer"
            >
              Discord server
            </a>{" "}
            before applying.
          </p>

          <p>
            Please do not spam requests. Applications are reviewed manually.
          </p>

          <p>
            Responses may take a while, Check your spam folder before contacting
            support.
          </p>
        </div>

        <div className="iframe-container">
          <iframe
            className="iframe"
            src="https://www.hng-group.com/jointest/join-test.aspx"
            title="Application Form"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            sandbox="allow-forms allow-scripts allow-same-origin"
          />
        </div>
      </div>
    </div>
  );
};

export default TestingApplication;
